export default {
    check(alarm, definition, value) {
        if (!definition) {
            return processOperator(alarm.operator, alarm.value, value)
        }
        switch (definition.panelType) {
            case 'stat':
                return processOperator(alarm.operator, alarm.value, value)
            case 'list':
                return processOperator(alarm.operator, alarm.value, value[alarm.column])
            case 'graph':
                // not sure how you would alarm a graph so...
                break;
        }
        return false;
    }
}

function processOperator(operator, input, value) {
    switch (operator) {
        case 'equals':
            return input == value;
        case 'no equal':
            return input != value;
        case 'contains':
            return value.indexOf(input) > -1
        case 'not contain':
            return value.indexOf(input) === -1
        case 'greater than':
            return value > input;
        case 'greater than or equal':
            return value >= input;
        case 'less than':
            return value < input;
        case 'less than or equal':
            return value <= input;
    }
}